export default {
  INACTIVE: 0,
  ACTIVE: 1,
  DISABLED: 2,
  WAITING_USER_ACTION: 3,
  ERROR: 4,
  WAITING_AUTHORIZATION: 5,
};
